import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import AppointmentForm from "@/components/site/AppointmentForm";
import Reviews from "@/components/site/Reviews";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingCall from "@/components/site/FloatingCall";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] text-zinc-950" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <AppointmentForm />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <FloatingCall />
    </div>
  );
}
